import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectLicensesQueryItems } from '../../../../../redux/licenses/selector';
import { licenses } from '../../../../../redux/licenses/action';
import LicenseComponent from '../components/license.component';
import { selectDomainsListItems } from '../../../../../redux/domains/selector';
import { domains } from '../../../../../redux/domains/action';
import * as R from "ramda"
const License= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectLicensesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [ selectedLicense, setSelectedLicense ] = useState<any>([])
    const domainItems = useSelector(selectDomainsListItems)
 
  const fetchLicenseById= ()=>{
    dispatch(licenses.query({
      url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/licenses/query`,
      entity:'licenses',
      jsonData:{
      Records: [
      {  
        "Id": parmas?.id      
      }
    ]
    }})).then(()=>{
      setIsQuery(true)
    })
  }
  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedLicense({ ...selectedLicense, [field]: event });
  }
  const handleFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedLicense({ ...selectedLicense, [fields[0]]: value });
  }
  useEffect(
    () => {  
         dispatch(domains.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/domains/list`,entity:'domains',jsonData:{
                }}))
      if (parmas?.id > 0) {
        fetchLicenseById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }      
    },
    []
  )


  useEffect(
    () => {  
      if (isQuery) {
        setSelectedLicense(queryItems?.result?.items)
      }
    },
    [isQuery]
  )
 
  const back=()=>{
    navigate('/management/platform-management/licenses')
  }
  
  return (
    <>
      {isLoading ? <PageLoader /> :
      <LicenseComponent
      tenantsDetails={selectedLicense}
       back={back}
       domains={domainItems?.result?.items}
       handleInnerFormChange={handleInnerFormChange}
       handleFormChange={handleFormChange}
      />  
      }
    </>
  )
 
}
 
export default License;